import { Controller } from "@hotwired/stimulus"
import { DateRangePicker } from "vanillajs-datepicker"
import { datepickerOptions, removeEmptyFormValues } from "@lib/utils"
import { setDateRange } from "@lib/date-utils"

const options = Object.assign(datepickerOptions, {
  allowOneSidedRange: true,
  autohide: true,
  format: "dd/mm/yyyy"
})

// Connects to data-controller="date-range"
export default class extends Controller {

  static targets = ["start", "end"]
  
  connect() {
    this.picker = new DateRangePicker(this.element, options)
  }

  submitForm() {
    removeEmptyFormValues(this.element.closest("form"))
    this.element.closest("form").requestSubmit()
  }

  onStartChange() {
    this.endTarget.focus()
  }

  onEndChange(e) {
    this.endTarget.blur()
  }

  clear() {
    this.picker.setDates(...setDateRange.clear())
  }

  today() {
    this.picker.setDates(...setDateRange.today())
  }

  yesterday() {
    this.picker.setDates(...setDateRange.yesterday())
  }

  tomorrow() {
    this.picker.setDates(...setDateRange.tomorrow())
  }

  week() {
    this.picker.setDates(...setDateRange.thisWeek())
  }

  lastWeek() {
    this.picker.setDates(...setDateRange.lastWeek())
  }

  nextWeek() {
    this.picker.setDates(...setDateRange.nextWeek())
  }

  month() {
    this.picker.setDates(...setDateRange.thisMonth())
  }

  lastMonth() {
    this.picker.setDates(...setDateRange.lastMonth())
  }

  nextMonth() {
    this.picker.setDates(...setDateRange.nextMonth())
  }

  year() {
    this.picker.setDates(...setDateRange.thisYear())
  }

  lastYear() {
    this.picker.setDates(...setDateRange.lastYear())
  }

  nextYear() {
    this.picker.setDates(...setDateRange.nextYear())
  }

  past() {
    this.picker.setDates(...setDateRange.past())
  }

  future() {
    this.picker.setDates(...setDateRange.future())
  }

  weekEnd() {
    this.picker.setDates(...setDateRange.weekEnd())
  }

  monthEnd() {
    this.picker.setDates(...setDateRange.monthEnd())
  }

  yearEnd() {
    this.picker.setDates(...setDateRange.yearEnd())
  }
  
}
